module.exports = __webpack_public_path__ + "media/IBMPlexSans-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-Bold.eot
// module id = 537
// module chunks = 58